import { apiClient } from "@/lib/api-client"
import type {
  PluginSummaryDto,
  PluginInstallDto,
  InstallPluginRequestDto,
  UpdatePluginInstallRequestDto,
  InstallPluginResultDto,
  MarketplaceConnectorStatusMap,
} from "../dtos/marketplace.dto"

export async function listPlugins(): Promise<PluginSummaryDto[]> {
  const response = await apiClient.get<PluginSummaryDto[]>(
    "/marketplace/plugins",
  )
  return response.data
}

export async function getConnectorStatuses(
  organizationId: string,
): Promise<MarketplaceConnectorStatusMap> {
  const response = await apiClient.get<MarketplaceConnectorStatusMap>(
    `/organizations/${organizationId}/marketplace/connectors`,
  )
  return response.data
}

export async function listInstalls(
  organizationId: string,
): Promise<PluginInstallDto[]> {
  const response = await apiClient.get<PluginInstallDto[]>(
    `/organizations/${organizationId}/marketplace/installs`,
  )
  return response.data
}

export async function installPlugin(
  organizationId: string,
  dto: InstallPluginRequestDto,
): Promise<InstallPluginResultDto> {
  const response = await apiClient.post<InstallPluginResultDto>(
    `/organizations/${organizationId}/marketplace/installs`,
    dto,
  )
  return response.data
}

export async function updatePluginInstall(
  organizationId: string,
  installId: string,
  dto: UpdatePluginInstallRequestDto,
): Promise<InstallPluginResultDto> {
  const response = await apiClient.put<InstallPluginResultDto>(
    `/organizations/${organizationId}/marketplace/installs/${installId}`,
    dto,
  )
  return response.data
}

export async function uninstallPlugin(
  organizationId: string,
  installId: string,
): Promise<InstallPluginResultDto> {
  const response = await apiClient.delete<InstallPluginResultDto>(
    `/organizations/${organizationId}/marketplace/installs/${installId}`,
  )
  return response.data
}

export const marketplaceApi = {
  listPlugins,
  getConnectorStatuses,
  listInstalls,
  installPlugin,
  updatePluginInstall,
  uninstallPlugin,
}
